/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import { get } from 'lodash';
import isString from 'lodash/isString';
import moment from 'moment';
import { getUser } from '../AppServices';
// import { purchaseSupplyOrderStatus } from './constants';
import permissions from './permissions';

export const regexps = {
  password: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/,
  //email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/,
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/,
  zipCode: /^[1-9][0-9]{5}$/,
  mobile: /^[1-9][0-9]{9}$/,
  mobileAdmin: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
  panCard: /[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  numberRegex: (decimalPlaces = 0) =>
    new RegExp(
      `^[0-9]+${decimalPlaces ? `(\\.[0-9]{0,${decimalPlaces}})?` : ''}$`,
    ),
  slashRegex: (decimalPlaces = 0) =>
    new RegExp(
      `^[0-9]+${decimalPlaces ? `(\\/[0-9]{0,${decimalPlaces}})?` : ''}$`,
    ),
  alphabetsWithSpaces: /^[a-zA-Z ]*$/,
  onlyNumber: /^\d+\.?\d*$/,
};

export const validateMileage = (value) => {
  if (!value) {
    return;
  }

  if (value === 'All') {
    return;
  }

  const result = regexps.onlyNumber.test(value);
  if (!result) {
    return 'This field must be a number';
  }
};

export const validateMinMileage = ({ min, type }) => {
  if (!min || type === 'All') {
    return;
  }

  console.log('type of min got->', typeof min);

  const result = regexps.onlyNumber.test(min);
  if (!result) {
    return 'This field must be a number';
  } else {
    if (parseInt(min) < 1000) {
      return 'Minimum mileage cannot be less than 1,000';
    }
  }
};

export const validateMaxMileage = ({ min, max, type }) => {
  if (type === 'All') {
    return;
  }
  if (!min) {
    return 'Enter minimum mileage first.';
  }

  if (!max) {
    return;
  }

  const result = regexps.onlyNumber.test(max);

  if (!result) {
    return 'This must be a number';
  }

  if (parseInt(max) < parseInt(min)) {
    return `Max mileage must be greater than min mileage`;
  }
};

const passwordValidationMessage =
  'Password must contain 8-30 characters. At least 1 letter, 1 numeric digit and 1 special character.';
export const validatePassword = (
  password,
  message = passwordValidationMessage,
) => {
  if (!password) {
    return;
  }
  const value = regexps.password.test(password);

  if (!value) {
    return message;
  }
};

export const validateConfirmPassword = (data, message = 'Invalid password') => {
  if (!data.newPassword) {
    return;
  }
  const value = regexps.password.test(data.newPassword);
  if (!value) {
    return message;
  }
  if (
    data.newPassword &&
    data.confirmPassword &&
    data.newPassword !== data.confirmPassword
  ) {
    return 'Passwords do not match. please re-enter';
  }
};

export const validateConfirmPasswordEmployee = (
  data,
  message = 'Invalid password',
) => {
  if (!data.password) {
    return;
  }
  const value = regexps.password.test(data.password);
  if (!value) {
    return message;
  }
  if (
    data.password &&
    data.confirm_password &&
    data.password !== data.confirm_password
  ) {
    return 'Passwords do not match. please re-enter';
  }
};

export const validateEmail = (email, message = 'Invalid Email') => {
  if (!email) {
    return;
  }
  const value = regexps.email.test(email);

  if (!value) {
    return message;
  }
};

export const validatePinCode = (zipCode, message = 'Invalid Pin code') => {
  if (!zipCode) {
    return;
  }
  const value = regexps.zipCode.test(zipCode);

  if (!value) {
    return message;
  }
};

export const validatePanCard = (panNumber, message = 'Invalid PanCard') => {
  if (!panNumber) {
    return;
  }
  const value = regexps.panCard.test(panNumber);

  if (!value) {
    return message;
  }
};

export const validateMobile = (mobile, message = 'Invalid Mobile Number') => {
  if (!mobile) {
    return;
  }
  const value = regexps.mobile.test(mobile);

  if (!value) {
    return message;
  }
};

export const validateAdminMobile = (
  mobile,
  message = 'Invalid Mobile Number',
) => {
  if (!mobile) {
    return;
  }
  const value = regexps.mobileAdmin.test(mobile);

  if (!value) {
    return message;
  }
};

export const validateInputLength = (
  data,
  minValue,
  maxValue,
  message = `Length should be in between ${minValue} to ${maxValue}`,
) => {
  if (!data) {
    return;
  }

  if (!isString(data)) {
    data = data.toString();
  }

  if (data?.length >= minValue && data?.length <= maxValue) {
    return;
  }

  return message;
};

export const validateFileTypesAllowed = (fileName, message, fileType = []) => {
  if (!fileName) {
    return;
  }

  const splitedName = fileName.split('.');

  const filetype = splitedName[splitedName.length - 1];
  let allowed = false;

  fileType.forEach((type) => {
    if (type === filetype) {
      allowed = true;
    }
  });

  if (!allowed) {
    return (
      message ||
      `only ${fileType.join(',')} is allowed. Please choose right file.`
    );
  }
};

export const validateMultipleFileTypesAllowed = (
  fileName,
  message,
  fileType = [],
) => {
  let allFilesOk = true;
  if (!fileName) {
    return;
  }
  fileName.forEach((file) => {
    const splitedName = file?.name?.split('.');

    const filetype = splitedName[splitedName.length - 1];

    let allowed = false;

    for (let i = 0; i < fileType.length; i++) {
      if (fileType[i] === filetype) {
        allowed = true;
      }
    }
    allFilesOk = allowed;
  });
  if (!allFilesOk) {
    return (
      message ||
      `only ${fileType.join(',')} is allowed. Please choose right file.`
    );
  }
};

export const validateDecimalInputLength = (
  data,
  decimalPoints,
  message = `You can input the only numbers up to ${decimalPoints} decimal places`,
) => {
  if (!data) {
    return;
  }

  if (regexps.numberRegex(decimalPoints).test(data)) {
    return;
  }

  return message;
};

export const validateSlashInputLength = (data, decimalPoints, message) => {
  if (!data) {
    return;
  }

  if (regexps.slashRegex(decimalPoints).test(data)) {
    return;
  }

  return message;
};

export const getString = (data, operator) =>
  data?.filter((item) => item).join(operator || ' ');

export const sortByKey = (array, key) =>
  array.sort((a, b) => {
    const x = a[key];
    const y = b[key];
    if (y < x) {
      return -1;
    } else if (y > x) {
      return 1;
    } else {
      return 0;
    }
  });

export const removeAllSpacesOnChange = ({ value }) => {
  if (value && typeof value === 'string') {
    value = value.split(' ').join('');
  }
  return value;
};

export const trimLeftValueOnChange = ({ value }) => {
  if (value && typeof value === 'string') {
    value = value.trimLeft();
  }
  return value;
};

export const trimValueOnBlur = ({ value }) => {
  if (value && typeof value === 'string') {
    value = value.trim();
  }
  return value;
};

export const formatNumberMaxTwoDecimalOnChange = ({ prevValue, value }) => {
  if (value) {
    if (typeof value === 'string') {
      value = Number(value);
    }
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(value)) {
      const strValue = value.toString();
      const splitValue = strValue.split('.');
      if (splitValue.length > 1) {
        if (splitValue[1].length > 2) {
          value = prevValue;
        }
      }
    }
  }
  return value;
};

export const getErrorString = (e) => {
  let errorResponse = e.response && e.response.data && e.response.data.response;
  if (errorResponse) {
    if (errorResponse && errorResponse.error && errorResponse.error.code) {
      errorResponse = errorResponse.error.code;
    } else {
      errorResponse = errorResponse?.error?.message;
    }
  } else {
    errorResponse = e.message;
  }
  return errorResponse;
};

export const validateAlphabetsWithSpaceOnly = (
  value,
  message = 'Special Characters are not allowed.',
) => {
  if (!value) {
    return;
  }

  if (regexps.alphabetsWithSpaces.test(value)) {
    return;
  }

  return message;
};

export const getModulesPermissions = () => {
  const permissionsKeys = Object.keys(permissions);
  const modules = {};
  for (let index = 0; index < permissionsKeys.length; index += 1) {
    const module = { ...permissions[permissionsKeys[index]] };
    const views = Object.values(module.views);
    const viewsArray = [];
    for (let viewsIndex = 0; viewsIndex < views.length; viewsIndex += 1) {
      const view = { ...views[viewsIndex] };
      view.permissions = Object.values(views[viewsIndex].permissions);
      viewsArray.push(view);
    }
    module.views = viewsArray;
    modules[permissionsKeys[index]] = module;
  }
  return modules;
};

export const getMyValue = (data, keyPath) => get(data, keyPath, '---');

export const validateShift = (data, message = '') => {
  const { startTime, endTime } = data;
  if (startTime === endTime) {
    message = 'Shift Time Should be greater than Zero Minutes.';
  }
  if (startTime > endTime) {
    message = 'Shift End Time Should be Greater than startTime';
  }
  return message;
};

export const validFromData = (data) => {
  const date = moment(data?.fromDate).format('DD');
  const month = moment(data?.fromDate).format('MM');
  const year = moment(data?.fromDate).format('YYYY');
  if (data?.toDate) {
    const todate = moment(data?.toDate).format('DD');
    const tomonth = moment(data?.toDate).format('MM');
    const toyear = moment(data?.toDate).format('YYYY');
    if (toyear < year || tomonth < month || todate < date) {
      if (month < tomonth || year < toyear) {
        return;
      }
      return 'to date should be greater than fromDate ';
    }
  }
};

export const validToData = (data) => {
  const date = moment(data?.toDate).format('DD');
  const month = moment(data?.toDate).format('MM');
  const year = moment(data?.toDate).format('YYYY');
  if (moment(data?.fromDate)) {
    const fromdate = moment(data?.fromDate).format('DD');
    const frommonth = moment(data?.fromDate).format('MM');
    const fromyear = moment(data?.fromDate).format('YYYY');
    if ((fromyear > year || frommonth > month, fromdate > date)) {
      if (month > frommonth || year > fromyear) {
        return;
      }
      return 'Effective to  should be greater than Effective from ';
    }
  }
};

export const validToAndFromDate = (data, message = '') => {
  if (!data) return message;

  if (data?.fromDate && data?.toDate) {
    const from = new Date(data?.fromDate);
    const to = new Date(data?.toDate);
    const value = from > to;
    // eslint-disable-next-line eqeqeq
    if (value == 1) {
      return message || 'To Date Should be greater than From Date';
    }
  }
};
export const validFutureDate = (data, message = '') => {
  if (!data) return message;

  if (data) {
    const from = new Date(data);
    const to = new Date();
    const value = from > to;
    if (value == 1) {
      return message || ' Date must be less than Current Date';
    }
  }
};

export const calculateRemainingSelfLife = (expiryDate) => {
  if (!expiryDate) return;
  const TodayDate = moment(new Date());
  const expDate = moment(new Date(expiryDate));
  return expDate.diff(TodayDate, 'days');
};

export const calculateTotalShelfLife = (manufacturingDate, expiryDate) => {
  const manufactureDate = moment(new Date(manufacturingDate));
  const expDate = moment(new Date(expiryDate));
  return expDate.diff(manufactureDate, 'days');
};

export const getIsLowShelfLife = (manufacturingDate, expiryDate) => {
  const totalLife = calculateTotalShelfLife(manufacturingDate, expiryDate);
  const remainingLife = calculateRemainingSelfLife(expiryDate);
  const percentageValue = (remainingLife / totalLife) * 100;
  return percentageValue <= 70;
};

export const getExpirationStatus = (date) => {
  const today = moment();
  if (today > moment(date)) {
    return 'Expired';
  }
  return 'Active';
};

export const getRemainingSelfValue = (date) => {
  const today = moment();
  const remainingDays = moment(date).diff(today, 'days');
  if (remainingDays > 0) {
    return remainingDays;
  }
  return '0';
};

export const getDaysLimitForApprovalForSO = (item) => {
  const today = moment();
  const daysLimitForApproval =
    item?.daysLimitForApproval - today.diff(item?._createdOn, 'days');

  return daysLimitForApproval <= 0
    ? '0 day left for approval'
    : `${daysLimitForApproval} days left for approval`;
};

export const getWeekDaysSchedule = (item) => {
  const days = [];
  if (item?.monday) {
    days.push('Mon');
  }
  if (item?.tuesday) {
    days.push('Tue');
  }
  if (item?.wednesday) {
    days.push('Wed');
  }
  if (item?.thursday) {
    days.push('Thu');
  }
  if (item?.friday) {
    days.push('Fri');
  }
  if (item?.saturday) {
    days.push('Sat');
  }
  if (item?.sunday) {
    days.push('Sun');
  }
  return days?.map((day) => ` ${day}`).toString();
};

export const isSuperadmin = (user) => {
  if (user?.role?.code?.toLowerCase() === 'superadmin') {
    return true;
  }

  const superadmin =
    Array.isArray(user?.role) &&
    user?.role.filter((role) => role?.code?.toLowerCase() === 'superadmin');
  if (superadmin && superadmin.length) {
    return true;
  }

  return false;
};

export const isCreateSoPermissionGiven = (user) => {
  const { role } = user;
  for (let i = 0; i <= role?.length; i++) {
    if (role[i].permissions?.inventory_purchase_create_supply_order)
      return true;
  }
};

export const reduceDaysLimitApprovalBasedOnRole = (
  daysLimitForApproval,
  createdOn,
  status,
  { isReview = false, approvalDaysLimit = 0 } = {},
) => {
  // if (
  //   status === purchaseSupplyOrderStatus?.APPROVED ||
  //   status === purchaseSupplyOrderStatus?.STOCK_ENTRY_PENDING
  // ) {
  //   return '--';
  // } else 
  if (isReview) {
    const days = moment(new Date()).diff(createdOn, 'days');
    if (approvalDaysLimit - days >= 0) {
      return `${approvalDaysLimit - days} days left for approval`;
    }
    return '0 days left for approval';
  } else if (daysLimitForApproval) {
    const days = moment(new Date()).diff(createdOn, 'days');
    const daysLimitForApprovalPerRole = Math.floor(daysLimitForApproval / 6);

    if (daysLimitForApprovalPerRole - days >= 0) {
      return `${daysLimitForApprovalPerRole - days} days left for approval`;
    } else {
      return '0 days left for approval';
    }
  } else {
    return '--';
  }
};

export const getMonthOfOperation = (
  soldOnDate = new Date(),
  _createdOn = new Date(),
) => {
  return moment(_createdOn).diff(soldOnDate, 'months');
};
export const getEstimatedDepreciationValue = (
  rate = 0,
  Principle = 0,
  months = 0,
) => {
  return Principle - Principle * (1 - rate / 100) ** (months / 12);
};

export const shorten = (input, need = 7) => {
  if (input && input.length > 7) {
    let comma = input.indexOf(',');
    let space = input.indexOf(' ');
    let res;
    if (comma >= 0) {
      if (comma >= 6) {
        return input.slice(0, need) + '...';
      }
      return input.slice(0, comma) + '...';
    }

    // if (space > 0) {
    //   if (input.lastIndexOf(' ') === input.length - 4)
    //     return input.slice(0, space) + '...';
    // }

    if (input.length > need) {
      let clipped_input = input.slice(0, need);
      if (clipped_input.lastIndexOf(' ') === need - 4) {
        // so that space is clipped before '...', if any
        res = input.slice(0, need - 4) + '...';
      } else {
        res = input.slice(0, need - 3) + '...';
      }
    } else {
      res = input.slice(0, need);
    }
    return input.length > need
      ? input.slice(0, need - 3) + '...'
      : input.slice(0, need);
  } else if (input && input.length <= 7) {
    return input;
  } else {
    return '--';
  }
};

export const getUserRole = () => {
  const user = getUser();
  let userRole = '';
  if (user?.role?.constructor === Array) {
    if (user.role[0].code === 'superadmin') {
      userRole = 'superadmin';
    }
  } else {
    if (user?.role?.code === 'superadmin') {
      userRole = 'superadmin';
    } else if (user?.role?.code === 'dealer') {
      userRole = 'dealer'; 
    } else if (user?.role?.code === 'superdealer') {
      userRole = 'superdealer'; 
    } else if (user?.role?.code === 'employee') {
      userRole = 'employee';
    } else if (user?.role?.code === 'manager') {
      userRole = 'manager'; }
    else {
      userRole = 'admin';
    }
  }
  return userRole;
};

export const modifyDateView = (value) => {
  if (value === '--') {
    return '--';
  }
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const d = new Date(value);
  const day = d.getDate();
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();

  return `${month} ${day}, ${year}`;
};
